
import { ResourceFile } from "./types";
import { 
  isQuizFile, 
  isFreeResponseFile, 
  isDragDropFile, 
  isLinkingFile 
} from "./utils/fileTypeUtils";
import { EmptyContentViewer } from "./content-viewers/EmptyContentViewer";
import { ErrorContentViewer } from "./content-viewers/ErrorContentViewer";
import { ContentTypeHandler } from "./content-viewers/ContentTypeHandler";

interface TrainingContentViewerProps {
  currentFile: ResourceFile | undefined;
  currentFileIndex: number;
  files: ResourceFile[];
  isQuizView: boolean;
  isFreeResponseView: boolean;
  isDragDropView: boolean;
  isLinkingView: boolean;
  isTrainee: boolean;
  isAdmin: boolean;
  isFileLocked: (index: number) => boolean;
  completedFiles: {[key: string]: boolean};
  overallProgress: number;
  resourceId: string;
  markFileCompleted: (fileId: string) => Promise<void>;
  quiz: any;
  isLoadingQuiz: boolean;
  quizCompleted: boolean;
  quizAttempt: any;
  handleQuizComplete: (quizId: string, attempt: any) => Promise<void>;
  handleContentComplete: () => void;
  handleDragDropComplete: (fileId: string, attempt: any) => Promise<void>;
  loadingError: string | null;
  setLoadingError: (error: string | null) => void;
  onComplete?: () => void;
  freeResponseQuestions: any[];
  quizError?: string | null;
}

export function TrainingContentViewer({
  currentFile,
  currentFileIndex,
  files,
  isQuizView,
  isFreeResponseView,
  isDragDropView,
  isLinkingView,
  isTrainee,
  isAdmin,
  isFileLocked,
  completedFiles,
  overallProgress,
  resourceId,
  markFileCompleted,
  quiz,
  isLoadingQuiz,
  quizCompleted,
  quizAttempt,
  handleQuizComplete,
  handleContentComplete,
  handleDragDropComplete,
  loadingError,
  setLoadingError,
  onComplete,
  freeResponseQuestions,
  quizError
}: TrainingContentViewerProps) {
  // Handle empty state
  if (!currentFile) {
    return <EmptyContentViewer />;
  }

  // Handle loading error state
  if (loadingError) {
    return (
      <ErrorContentViewer 
        message={loadingError} 
        onRetry={() => setLoadingError(null)} 
      />
    );
  }

  // Render appropriate content handler
  return (
    <ContentTypeHandler
      currentFile={currentFile}
      currentFileIndex={currentFileIndex}
      files={files}
      isQuizView={isQuizView}
      isFreeResponseView={isFreeResponseView}
      isDragDropView={isDragDropView}
      isLinkingView={isLinkingView}
      isTrainee={isTrainee}
      isAdmin={isAdmin}
      isFileLocked={isFileLocked}
      completedFiles={completedFiles}
      overallProgress={overallProgress}
      resourceId={resourceId}
      quiz={quiz}
      isLoadingQuiz={isLoadingQuiz}
      quizCompleted={quizCompleted}
      quizAttempt={quizAttempt}
      handleQuizComplete={handleQuizComplete}
      handleContentComplete={handleContentComplete}
      handleDragDropComplete={handleDragDropComplete}
      onComplete={onComplete}
      onError={setLoadingError}
      error={quizError}
    />
  );
}
